import React, { useState } from 'react';
import { CardActionArea } from '@mui/material';
import Box from '@mui/material/Box';

interface CardProductComponentProps {
  backgroudCard: string;
  onClick: () => void;
  image: string;
  imageHover: string;
}

const CardProductComponent = ({
  backgroudCard,
  onClick,
  image,
  imageHover,
}: CardProductComponentProps) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <CardActionArea
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        borderRadius: '20px',
        background: backgroudCard,
        backgroundSize: '200% 200%',
        transition:
          'transform 0.3s ease-in-out, box-shadow 0.6s ease-in-out, background-position 0.8s ease-in-out',
        '&:hover': {
          transform: 'scale(1.05)',
          backgroundPosition: '100% 55%',
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: { xs: '25vh', sm: '25vh', md: '35vh' },
          height: { xs: '29vh', sm: '29vh', md: '20vh' },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={image}
          alt="Placeholder"
          style={{
            position: 'absolute',
            transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
            opacity: isHovered ? 0 : 1,
            width: '80%',
            height: 'auto',
          }}
        />

        <img
          src={imageHover}
          alt="Hover Placeholder"
          style={{
            position: 'absolute',
            transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',
            opacity: isHovered ? 1 : 0,
            width: '80%',
            height: 'auto',
          }}
        />
      </Box>
    </CardActionArea>
  );
};

export default CardProductComponent;
